<template>
    <div class="room__messagebox">
        <span class="room__caption">Ваша консультация завершена</span>
        <div class="room__message-text" v-if="!user.doctor">
            <p v-if="!notEmptyState(report)">
                Отчёт и рецепт скоро будут доступны
            </p>
            <p v-else-if="notEmptyState(report) && !notEmptyState(recept)">
                Вы можете скачать <a :href="/report/ + consultation.id + /download/">отчёт</a>
            </p>
            <p v-else-if="notEmptyState(report) && notEmptyState(recept)">
                Вы можете скачать <a :href="/report/ + consultation.id + /download/">отчёт</a> и <a :href="/recept/ + consultation.id + /download/">рецепт</a>
            </p>
        </div>
        <div class="room__message-text" v-else-if="user.doctor && !notEmptyState(report)">
            <p>
                Не забудьте загрузить отчёт
            </p>
        </div>
        <div class="room__actions">
            <div class="room__action b-attach" v-if="user.doctor && !notEmptyState(report)">
                <label class="b-attach__button">
                    <input type="file" class="b-attach__input" @change="upload" ref="report_file">
                    <span class="b-attach__text button">Прикрепить отчёт</span>
                </label>
            </div>
            <a href="/account/dashboard" class="room__action r-link button button_secondary">Перейти к уведомлениям</a>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapMutations, mapState} from 'vuex';

    export default {
        name: 'ConsultationInfo',
        computed: {
            ...mapState([
                'user',
                'consultation'
            ]),
            ...mapState('report', [
                'report'
            ]),
            ...mapState('recept', [
                'recept'
            ])
        },
        methods: {
            upload() {
                let formData = new FormData();

                this.file = this.$refs.report_file.files[0];

                formData.append('file', this.file);

                this.postReport(formData);
            },
            notEmptyState(object){
                return object ? Object.keys(object).length : false;
            },
            ...mapActions('report', [
                'postReport'
            ]),
            ...mapMutations('report', [
                'setReport',
                'spliceReport'
            ]),
            ...mapMutations('recept', [
                'setRecept',
                'spliceRecept'
            ])
        }
    }
</script>
